import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CustomerTable from './components/CustomerTable';

const CustomerTables = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Customers</h3>
        <h3 className="page-subhead subhead">Current Customer List</h3>
      </Col>
    </Row>
    <Row>
      <CustomerTable />
    </Row>
  </Container>
);

export default CustomerTables;
